import { Component, HostListener, OnInit } from '@angular/core';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';

@Component({
  standalone:true,
  selector: 'app-move-to-private-folder',
  templateUrl: './move-to-private-folder.component.html',
  styleUrls: ['./move-to-private-folder.component.scss'],
  imports:[DependenciesModule]
})
export class MoveToPrivateFolderComponent implements OnInit {
  public universalService: any;
  public moveToPrivateFolderConfirmation:boolean = false;
  listService:any;
  localStorageService: any;
  sessionStorageService: any;


  @HostListener('document:keydown', ['$event'])
   onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && this.moveToPrivateFolderConfirmation) {
      this.closePopUp();
    }else if(event.key === "Enter" && this.moveToPrivateFolderConfirmation){
     this.continueMove();
    }
  }

  constructor(public globalService:GlobalService) {
    this.setEnvObjects(globalService);
   }

  ngOnInit(): void {
    AppEvents.optionSelected.subscribe(ev=>{
      if(ev["moveToPrivateFolder"]){
        this.checkIfMoveConfirmationSupposedToBeShown();
      }else if(ev["initiateMoveToPrivateFolder"]){
        this.moveToPrivateFolderConfirmation = false;
        this.initiateMoveToPrivateFolder();
      }else if(ev["closeAll"]){
        this.moveToPrivateFolderConfirmation = false;
      }
    })
  }


  checkIfMoveConfirmationSupposedToBeShown(){
    const isPrivateSharedFilesPresent = this.universalService.selectedNodes.some(obj=> {
      var type = obj["FullObject"]?obj["FullObject"]:obj;
      return type["shareType"] == "R"; 
    })
    this.moveToPrivateFolderConfirmation = isPrivateSharedFilesPresent ? true : false;

    var userData = this.localStorageService.getUserData(true);
    if(userData["privateFolder"] && userData["privateFolder"]["moveConfirmationAlreadyAccepted"]){
      this.moveToPrivateFolderConfirmation = false;
      this.continue();
    }else{
      if(!this.moveToPrivateFolderConfirmation){
        this.continue();
      }
    }
  }


  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
  }

  initiateMoveToPrivateFolder(){
    AppEvents.optionSelected.next({confirmMoveToPrivateFolder:true});
  }

  closePopUp(){
    this.listService.deSelectAll()
  }


  continueMove(){
    var ele = <HTMLInputElement>document.getElementById("checkbox-1");
    if(ele.checked){
      var userData = this.localStorageService.getUserData(true);
      userData["privateFolder"]["moveConfirmationAlreadyAccepted"] = true;
      AppEvents.updateAuthData.next({updateAuthData:true,userData:userData});
    }
    this.continue();
  }

  continue(){
    this.moveToPrivateFolderConfirmation = false;
    let currentTme = new Date().getTime();//current time
    let lastPPFTime = this.sessionStorageService.getPrivateFolderPasswordTime();
    let time = lastPPFTime ? lastPPFTime : currentTme;
    let timeDifference = currentTme - time;
    let passedTime = this.universalService.msToTime(timeDifference);
    if((lastPPFTime == null || passedTime.minute >= ENV_CONSTANTS["constants"]["Interval_PPF"])){
      AppEvents.globalObservable.next({showPrivateFoldePassword: true,nextOperation:{'initiateMoveToPrivateFolder':true}})
    }else{
      AppEvents.optionSelected.next({'initiateMoveToPrivateFolder':true});
    }
  }

  

  cancel(){
    
  }

}
